import { render, staticRenderFns } from "./Bulten.vue?vue&type=template&id=57835d27&scoped=true&"
import script from "./Bulten.vue?vue&type=script&lang=js&"
export * from "./Bulten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57835d27",
  null
  
)

export default component.exports